import React from 'react';
import { motion } from 'framer-motion';
import BackgroundVideo from './BackgroundVideo';

const Hero = () => {
    const videoSources = [
        { src: '/assets/video/hero/video_1.av1.mp4', type: 'video/mp4; codecs=av01.0.05M.08' },
        { src: '/assets/video/hero/video_1.h265.mp4', type: 'video/mp4; codecs=hvc1' },
        // Fallback logic handled by browser (if neither matches, it won't play or we need a standard mp4/webm without specific codecs if very old)
        // But per plan we have these two. User mentioned VP9/H.264 fallback but didn't provide assets. 
        // I will stick to these two as verified in the directory.
    ];

    return (
        <section className="relative h-screen w-full overflow-hidden">

            {/* 1. BACKGROUND VIDEO & OVERLAY */}
            <div className="absolute inset-0 w-full h-full z-0">
                <BackgroundVideo
                    poster="/assets/video/hero/foto_1.webp"
                    sources={videoSources}
                    className="w-full h-full object-cover opacity-80"
                />

                {/* Overlay Gradiente */}
                <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-transparent to-black/90 z-10 pointer-events-none"></div>
            </div>

            {/* 2. CONTENUTO CENTRALE */}
            {/* Added -mt-20 for Optical Centering (Compensates for Navbar and visual balance) */}
            <div className="relative z-20 h-full flex flex-col justify-center items-center text-center px-4 -mt-16 md:-mt-20">

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: 'easeOut' }}
                    className="flex flex-col items-center"
                >
                    {/* LOGO ADER - Ripristinato & Ingrandito */}
                    <img
                        src="/assets/video/hero/logo_ADER.png"
                        alt="Ader SRL Logo"
                        className="h-32 md:h-48 lg:h-64 mb-8 object-contain drop-shadow-2xl"
                    />

                    {/* Titolo Principale */}
                    <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white tracking-tight mb-6 drop-shadow-lg">
                        COSTRUIAMO <br className="md:hidden" />
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-100 to-gray-400">
                            L'ECCELLENZA
                        </span>
                    </h1>

                    {/* Sottotitolo */}
                    <p className="text-lg md:text-2xl text-gray-300 max-w-3xl font-light leading-relaxed drop-shadow-md">
                        Coperture industriali e smaltimento amianto. <br className="hidden md:block" />
                        Tecnologia, sicurezza e design per il futuro dell'edilizia.
                    </p>
                </motion.div>

            </div>

            {/* 3. INDICATORE SCROLL */}
            <div className="absolute bottom-24 md:bottom-10 left-1/2 -translate-x-1/2 z-20">
                <motion.div
                    initial={{ opacity: 0, y: 0 }}
                    animate={{
                        opacity: 1,
                        y: [0, 10, 0]
                    }}
                    transition={{
                        opacity: { duration: 1, delay: 1 },
                        y: { duration: 2.5, repeat: Infinity, ease: "easeInOut" }
                    }}
                    className="flex flex-col items-center gap-2"
                >
                    <span className="text-xs uppercase tracking-widest text-gray-400">Scroll</span>
                    <div className="w-[2px] h-12 bg-white/50 rounded-full"></div>
                </motion.div>
            </div>

        </section>
    );
};

export default Hero;
